import { Box, Stack, Typography } from '@mui/material';
import { Fragment, memo } from 'react';
import { theme } from 'theme';
import { StyledStatusPanel, StyledStepper } from './styles';

export interface StatusPanelStep {
  label: string;
  active: boolean;
  activeLabel: boolean;
}

interface StatusPanelProps {
  steps: StatusPanelStep[];
}

export const StatusPanel = memo(({ steps }: StatusPanelProps) => {
  return (
    <StyledStatusPanel>
      <Box className="panel_header">
        <Typography variant="Web_Title_18">Request Status</Typography>
      </Box>
      <Stack className="panel_body">
        {steps.map((step, idx) => {
          return (
            <Fragment key={idx}>
              {idx !== 0 && (
                <StyledStepper className={step.active ? 'active' : ''} />
              )}
              <Stack spacing={1} justifyContent="center" alignItems="center">
                <Box
                  width="26px"
                  height="26px"
                  borderRadius="50%"
                  bgcolor={step.active ? theme.palette.primary.main : '#D9D9D9'}
                />
                <Stack alignItems="center">
                  <Typography
                    variant="Small_Profile_16"
                    color={
                      step.activeLabel ? theme.palette.primary.main : '#B6B6B6'
                    }
                    whiteSpace={'nowrap'}
                  >
                    {step.label}
                  </Typography>
                </Stack>
              </Stack>
            </Fragment>
          );
        })}
      </Stack>
    </StyledStatusPanel>
  );
});

export default StatusPanel;
